// components/AdminLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Alert, Card } from 'antd';
import axios from 'axios';
import { ADMIN_API_BASE } from '../adminApi';
// Plain axios (not the adminApi instance) - signin has no token yet, and we don't want
// the adminApi 401 interceptor redirecting mid-login on a bad password.

function AdminLogin() {
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (values) => {
    setLoginError('');
    setLoading(true);
    try {
      const response = await axios.post(`${ADMIN_API_BASE}/api/admin/auth/signin`, {
        username: values.username,
        password: values.password,
      });
      localStorage.setItem('adminToken', response.data.accessToken);
      navigate('/admin');
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setLoginError('This account does not have admin access.');
      } else if (error.response && error.response.status === 401) {
        setLoginError('Invalid username or password.');
      } else {
        setLoginError('Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <Card title="Admin Login" style={{ width: 360 }}>
        {loginError && <Alert message={loginError} type="error" showIcon style={{ marginBottom: 16 }} />}
        <Form layout="vertical" onFinish={handleLogin}>
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please enter your username' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please enter your password' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default AdminLogin;
